import { uuid } from "@/lib/format";

const KEY = "tm_terminals";
const CUR = "tm_current";
const today = () => new Date().toISOString().slice(0, 10);

export const getTerminals = () => {
  const l = JSON.parse(localStorage.getItem(KEY) || "null");
  return l?.length ? l : [{ id: "t1", name: "TPV 1", pos: "TIENDA", date: today() }];
};
const save = (l) => { localStorage.setItem(KEY, JSON.stringify(l)); return l; };
export const getCurrent = () => getTerminals().find((x) => x.id === localStorage.getItem(CUR)) || null;
export const openTerminal = (id) => {
  const l = save(getTerminals().map((x) => (x.id === id ? { ...x, date: today() } : x)));
  localStorage.setItem(CUR, id);
  return l.find((x) => x.id === id);
};
export const addTerminal = (name, pos) => save([...getTerminals(), { id: uuid(), name, pos, date: today() }]);
